const EXTENSION_TO_AUDIO_MIME: Record<string, string> = {
  ".mp3": "audio/mpeg",
  ".wav": "audio/wav",
};

const ALLOWED_AUDIO_MIME_TYPES = new Set(["audio/mpeg", "audio/wav"]);

function getFilenameExtension(filename: string): string {
  const lastDot = filename.lastIndexOf(".");
  if (lastDot <= 0) {
    return "";
  }
  return filename.slice(lastDot).toLowerCase();
}

/**
 * Normalize browser/OS MIME quirks for audio uploads.
 * Handles audio/mp3 -> audio/mpeg, audio/x-wav -> audio/wav,
 * and infers MIME type from extension when empty or octet-stream.
 */
export function normalizeAudioContentType(
  fileType: string | undefined,
  filename: string
): string {
  let contentType = (fileType ?? "").split(";")[0]?.trim().toLowerCase() ?? "";

  if (contentType === "audio/mp3") {
    contentType = "audio/mpeg";
  } else if (contentType === "audio/x-wav") {
    contentType = "audio/wav";
  }

  if (!contentType || contentType === "application/octet-stream") {
    contentType = EXTENSION_TO_AUDIO_MIME[getFilenameExtension(filename)] ?? "";
  }

  if (ALLOWED_AUDIO_MIME_TYPES.has(contentType)) {
    return contentType;
  }

  // Fallback to extension-based MIME or default audio/wav
  return EXTENSION_TO_AUDIO_MIME[getFilenameExtension(filename)] || "audio/wav";
}
